/**
 * Цель - сделать самую лучшую, самую удобную, самую надёжную программу по расчёту систем ОВ
 * ВНИМАНИЕ!!! Программа не должна превращаться во Франкенштейна!
 * 
 * На данный момент есть следующие сложности:
 * глобальные данные, например a.line изменяются в разных частях программы,
 * поэтому нужно запоминать, в каких частях и в какой последовательности они меняются.
 * 
 * 
 * TODO
 * добавить магниты к отводам
 * сделать так, чтобы точки присоединения отводов работали корректно
 * сделать так, чтобы труба перемещалась вместе с отводами, и отводы вместе с трубой, если они соединены
 * сделать надёжный механизм определения маршрута по соединениям элементов
 * перемещение блока вместе в трубой, к которой он присоединён
 * масштабирование блоков
 * ошибка, при которой иногда каким-то образом сам по себе меняется масштаб чертежа
 * таблица с местными сопротивлениями часто используемых элементов
 * свойства условных обозначений - диаметр, КМС и так далее
 * шрифт
 * специальные символы в тексте
 * прямоугольник не поворачивается!
 * zoom окном
 * отмена действий
 * области печати до вывода в PDF
 * модуль отопления
 * модуль вентиляции
 * при попытке разорвать линию пропадает половина чертежа (случается редко, разобраться с функцией break)
 * 
 * 
 * DONE
 * dxf текст. Нужно было использовать шрифт cyrillic_ii
 * При панорамировании иногда съезжает текст, разобраться. Похоже, что текст съезжает, если быстро нажать и отпустить space и при этом быстро передвинуть мышь. Проблему это не решает, но хотя бы теперь вроде бы известна причина. Если держать space дольше, текст не съезжает. Причина была в том, что для webgl в функции move использовалась функция requestAnimationFrame, а для canvas-text - нет. В итоге функции handleMouseMove двух модулей выполнялись с разной частотой. То есть в какой-то момент функция handleMouseMove какого-то из модулей выполнялась дополнительное число раз, что и приводило к разности смещений pan.tx/pan.ty.
 * 
 * толщина линий для круга - сделано путём получения всех 4320 вершин. Были различные попытки решить эту задачу, в том числе через фрагментный шейдер. Через фрагментный шейдер в принципе всё работает хорошо, но круг в этом случае не является полым и перекрывает другие фигуры. В процессе исследований выяснено следующее:
 * DYNAMIC_DRAW - очень сильно ускоряет операцию gl.bufferData
 * Присваивание массива переменной в JavaScript выполняется очень быстро. Таким образом, если вершины фигур простые, можно в цикле отрисовки просто напросто
 * каждый раз получать новые вершины и выполнять gl.bufferData - производительность будет близка к максимальной (это если не использовать InstancedDrawing)
 * С дальнейшим изучением языка шейдеров и webgl может появится более производительный способ выполнить цикл отрисовки. Например использовать InstancedDrawing - тогда возможно отрисовать все скажем 10000 линий на чертеже просто за один проход
 * Также для сложных фигур, таких как круг толстыми линиями, может быть есть какой-то способ сохранять вершины в переменной класса shape, чтобы при отрисовке уже существующей фигуры просто получать эти вершины, а не вычислять каждый раз заново.
 * В целом нужно работать над циклом отрисовки - ситуация, когда программа с 10 000 фигур на чертеже начинает тормозить конечно ненормальна. Мне кажется, что путь улучшения здесь - использовать InstancedDrawing.
 * модуль назначения сочетаний клавиш. Должно быть возможно назначать последовательные сочетания как в Revit
 * окно свойств - назначение размера воздуховода или трубы
 * */


/**
 * ********* РАСЧЁТЫ, ПОЯСНЕНИЯ *********
 * В текущей версии программы расчёты выполняются в компоненте ObjectProperties, из которого изменяются параметры класса NetworkInfo.
 * При изменении положения/длины отрезков, автоматически длина и соответственно потери давления, не пересчитываются
 */

import { a, getDisplayedShapes, getLinesIfSelected } from './shared/globalState/a.ts';
import { s as settings } from './shared/globalState/settings';
import { g } from "./shared/globalState/g";

import { registerSpacebarEvents } from "./handlers/keyboard/spacebar";
import { Line } from './models/shapes/Line.ts';
import { Rectangle } from './models/shapes/Rectangle.ts';
import { Circle } from './models/shapes/Circle.ts';
import { Block } from './models/shapes/Block.ts';
import { updateAndDrawShapes } from './shared/render/shapes';
// --- canvas-text
import { initCanvasText } from './libs/canvas-text/src/index';
import { TextBlock } from './libs/canvas-text/src/models/TextBlock';
import { textLinesCollection$ } from './libs/canvas-text/src/shared/state';
import { cnv } from './libs/canvas-text/src/shared/cnv';
// --- database
import { list as dbList, initialize as dbInitialize, addPredefinedAliases as _addPredefinedAliases, addPredefinedBlocks } from './services/database.ts'

import { getRealScale } from './shared/common';
import { ConnectionPoint as _ConnectionPoint } from './models/nets/ConnectionPoint.ts';
import { Point } from './models/Point';
import { checkConnections } from './services/operations.ts';
import { ObjectTypes } from "./shared/enums.ts";
import { inject as _inject } from '@vercel/analytics';



/**
 * В этой версии программы попробуем осущещствлять вызовы к webgl только из текущего файла.
 * Когда вызовы к webgl осуществляются из различных классов, возникает серьёзная путаница.
 * В этой версии есть потенциал серьёзного увеличения производительности из-за того,
 * что можно исключить проход функцией drawShapes в цикле по массиву a.shapes,
 * а отрисовывать вершины a.vertices. 
 * При всяком изменении массива a.shapes, например при операциях pan, zoom ... 
 * обновляется и массив вершин a.vertices
 * 
 * ЗАМЕТКИ ПО СТРУКТУРЕ ПРОГРАММЫ
 * Обработчики событий разбиты на файлы. В том же файле располагается функция регистрации обработчика события.
 * Больше нигде обработчики событий не регистрируются, исключение составляет файл page.js, в котором регистрируются
 * обработчики для кнопок и клавиш. Чтобы узнать все места, где регистрируются обработчики, можно выполнить глобальный поиск.
 * Для текста используется отдельная билиотека canvas-text. Коллекция строк текста в этой библиотеке располагается
 * в массиве textLinesCollection. В главной программе этот массив можно менять непосредственно, но добавлять и удалять элементы
 * в нём допускается только через вызов издателя textLinesCollection$, что привёдет к вызову соответствующих функций внутри canvas-text
 * Узнать все места, где производятся операции над массивом textLinesCollection можно простым поиском.
 * Библиотека canvas-text регистрирует свои собственные события. Получается, что на какие-то события появляется две функции-обработчика.
 * События главной программы обычно должны выполнятся первыми,
 * в том числе потому что функции магнитов располагаются в главной программе. И вот в этом случае регистрировать события главной программы
 * также нужно первыми.
 * 
 * КОММЕНТАРИЙ К ОПЕРАЦИЯМ
 * *** join ***
 * На данный Операция join выполняется только в модуле down, и только при присоединении участков
 * 
 */

// аналитика vercel.com
// inject();

// инициализация webgl canvas перенесена в компонент CanvasShapes

// инициализация библиотеки canvas-text
initCanvasText('.text', g.context.canvas.width, g.context.canvas.height, 'gost_type_a');

(function init() {
    settings.tolerance = 10;
    settings.aspectRatio = g.canvas.height / g.canvas.width;
    settings.format = 'a4';


})();

// resizeObserver
var resizeObserver = new ResizeObserver((_entries) => {

    // TODO: при проблемах с производительностью это можно оптимизировать. Пока предполагается, что
    // размер окна будет меняться нечасто
    let webGlCanvas = document.querySelector('canvas.drawing');
    g.init(webGlCanvas);
    cnv.init('canvas.text', g.canvas.width, g.canvas.height, 'gost_type_a');


    settings.aspectRatio = g.canvas.height / g.canvas.width;


});

resizeObserver.observe(g.canvas);

// --- events registration
registerSpacebarEvents();

// --- Database: Переменная, хранящая объекты из базы данных, если таковые имеются
dbInitialize();
dbList();
addPredefinedBlocks();

a.storedShapes$.subscribe((storedShapes) => {

    if (storedShapes.length > 0) {
        for (const shape of storedShapes) {
            
            extractShapesFromDb(shape);
        }
        let segments = getLinesIfSelected();
        getDisplayedShapes().forEach(s=>checkConnections(s,segments));
        updateAndDrawShapes();
    }


    function extractShapesFromDb(shape) {

        switch (shape.type) {
            case ObjectTypes.line: {
                const start = new Point(shape._start.x, shape._start.y);
                const end = new Point(shape._end.x, shape._end.y);
                const line = new Line(start, end, shape.color, shape.thickness);
                line.id = shape.id;
                line.joinedStart = shape.joinedStart;
                line.joinedEnd = shape.joinedEnd;
                line.rtype = shape.rtype;
                line.routeId = shape.routeId;
                a.shapes.push(line);
                break;
            }
            case ObjectTypes.rectangle: {
                const p1 = new Point(shape._p1.x, shape._p1.y);
                const p2 = new Point(shape._p2.x, shape._p2.y);
                const p3 = new Point(shape._p3.x, shape._p3.y);
                const p4 = new Point(shape._p4.x, shape._p4.y);
                const width = shape._width;
                const height = shape._height;

                const rectangle = new Rectangle(p1, p2, p3, p4, width, height, shape.color, shape.thickness);
                rectangle.rtype = shape.rtype;

                a.shapes.push(rectangle);
                break;
            }
            case ObjectTypes.circle: {
                let center = new Point(shape._center.x, shape._center.y);
                const circle = new Circle(center, shape._radius, shape.color, shape.thickness);
                circle.rtype = shape.rtype;
                a.shapes.push(circle);
                break;
            }
            case ObjectTypes.block: {
                let free = Block.restoreFromDatabase(shape);
                
                
                a.shapes.push(free);
                break;
            }
            default:
                break;
        }
    }
});
a.storedText$.subscribe((storedText) => {
    if (storedText.length > 0) {
        for (const textObject of storedText) {
            let textBlock = new TextBlock(textObject.start, textObject.textArray, textObject.fontSize, textObject.color);
            textBlock.rtype = textObject.rtype;
            textLinesCollection$.next({ fnName: 'push', line: textBlock });
        }
    }
});
// ** подписка на события
a.drawingMode$.subscribe(drawingMode => {
    a.drawingMode = drawingMode;
  });

/**
 * TODO: после сохранения и восстановления чертежа, у сохранённых в коллекции блоков меняется размер
 */
a.zlc = !localStorage.getItem('zlc') ? 1 : localStorage.getItem('zlc');
a.realScale$.next(getRealScale());




